import rolesList from '@/store/constants/roles.constants';
import states from '@/store/constants/states.constants';
import priorities from '@/store/constants/priorities.constants';
import accountTypes from '@/store/constants/accounts.constants';

const state = {
  // Global Changes
  appTitle: 'Aliha',
  appCaption: 'Asistente Personal',
  placeholderURL: 'https://via.placeholder.com/150/ccc/888?text=Your+Avatar',
  // Auth Settings
  isAuthPage: true,
  isLoginPage: false,
  isRegisterPage: false,
  isForgotPasswordPage: false,
  // User Settings
  user: null,
  // Snacbar Settings
  showSnackbar: false,
  snackbarDefaults: {
    message: 'Error occured, please contact admin!',
    timeout: 4000,
    color: '',
    vertical: false,
  },
  navigation: {
    elevation: 1,
    // color: 'primary',
    // dark: true,
  },
  snackbarConfig: {
    color: '',
    message: '',
  },
  // ROLES
  rolesList,
  // Dropdowns
  dropdowns: {
    sizes: {
      sm: 200,
      md: 240,
      lg: 320,
      xlg: 480,
    },
  },
  // Issue Priorities
  priorities,
  states,
  accountTypes,
};

export default state;
